import {config} from '@/api/configService/client';

const api = {
  config,
};

export type {Configs, ConfigParams} from '@/api/configService/client';

export default api;
